import { Building2, CircleUserRound, FileSignature } from 'lucide-vue-next'
import { Groups, JSSchema } from 'pejer/src/tables'
import { ColorPalette } from 'pejer/src/tables/helpers'

export namespace PersonsOfInterest {
  export interface Full extends ListItem {}

  export interface ListItem {
    id: number
    countryCode: string
    organizationId: string
    businessName: string
    platformName: string
    listSource: string
    name: string
    title: string
    signatureRequired: string
    signedAt: string
    signatureEmail: string
    signatureUrl: string
    lastNotifiedAt: string
    titleList: string[] | null
  }
}

export const PersonsOfInterestGroups = {
  Personlig: {
    color: ColorPalette.green,
    icon: CircleUserRound,
    isMainGroup: true,
    mainColumn: 'name',
  },
  Business: {
    color: ColorPalette.blue,
    icon: Building2,
    mainColumn: 'businessName',
  },
  Signert: {
    color: ColorPalette.purple,
    icon: FileSignature,
    mainColumn: 'signedAt',
  },
} satisfies Groups<PersonsOfInterest.ListItem>

export const PersonsOfInterestListSchema: JSSchema<
  PersonsOfInterest.ListItem,
  typeof PersonsOfInterestGroups
> = {
  name: 'Persons Of Interest',
  title: 'Persons of Interest',
  groups: PersonsOfInterestGroups,
  fields: {
    countryCode: {
      type: 'string',
      humanReadable: 'Landkode',
      meta: {
        group: 'Business',
      },
      metaType: 'countryCode',
    },
    organizationId: {
      type: 'string',
      humanReadable: 'Organisasjonsnummer',
      meta: {
        group: 'Business',
      },
      sensitive: true,
    },
    businessName: {
      type: 'string',
      humanReadable: 'Bedriftsnavn',
      meta: {
        group: 'Business',
      },
    },
    platformName: {
      type: 'string',
      humanReadable: 'Plattformnavn',
      meta: {
        group: 'Business',
      },
    },
    listSource: {
      type: 'string',
      humanReadable: 'Kilde',
      meta: {
        group: 'Personlig',
      },
    },
    name: {
      type: 'string',
      humanReadable: 'Navn',
      meta: {
        group: 'Personlig',
      },
      sensitive: true,
      inSearchSelect: true,
    },
    // title: {
    //   type: 'string',
    //   humanReadable: 'Tittel',
    //   meta: {
    //     group: 'Personlig',
    //   },
    // },
    titleList: {
      type: 'string',
      humanReadable: 'Company titles',
      meta: {
        group: 'Personlig',
      },
      metaType: 'array',
    },
    signatureRequired: {
      type: 'date',
      humanReadable: 'Signatur påkrevd',
      meta: {
        group: 'Signert',
        hideIfEmpty: true,
      },
    },
    signedAt: {
      type: 'date',
      humanReadable: 'Signatur dato',
      meta: {
        group: 'Signert',
      },
    },
    signatureEmail: {
      type: 'string',
      humanReadable: 'Signatur e-post',
      meta: {
        group: 'Signert',
      },
      sensitive: true,
    },
    signatureUrl: {
      type: 'string',
      humanReadable: 'Signatur URL',
      meta: {
        group: 'Signert',
      },
      metaType: 'url',
      sensitive: true,
    },
    lastNotifiedAt: {
      type: 'date',
      humanReadable: 'Sist varslet',
      meta: {
        group: 'Signert',
      },
    },
    id: {
      type: 'number',
      humanReadable: 'ID',
      meta: {
        group: 'Personlig',
      },
      isDefaultSortColumn: true,
    },
  },
}

// Warning list schema is the same as full schema, but if this changes in the future, we need to change it here
export const PersonsOfInterestFullSchema: JSSchema<
  PersonsOfInterest.Full,
  typeof PersonsOfInterestGroups
> = {
  ...PersonsOfInterestListSchema,
  title: 'Person of Interest',
}
